interface Props {
  className?: string;
}

export default function FrenchBedIcon({ className }: Props) {
  return (
    <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32">
      <path d="M26.688 15.688v-6.375h-21.375v6.375c2.375-0.563 5.813-1 10.688-1s8.313 0.438 10.688 1zM29.313 16.563c2.313 1.063 2.688 2.125 2.688 2.125v10.625h-2.688v-2.625h-26.625v2.625h-2.688v-10.625c0 0 0.375-1.063 2.688-2.125v-13.875h2.625v4h21.375v-4h2.625zM29.313 24v-4c0 0-2.625-2.688-13.313-2.688s-13.313 2.688-13.313 2.688v4z">
      </path>
    </svg>
  );
}
